'use strict';

import {module} from '../app';

module.filter('camelize', [function() {
   return function(input) {
       return input.toLowerCase().replace(/(?:^|\s)\w/g, function(match) {
        return match.toUpperCase();
    });
  };
}]);



// WEBPACK FOOTER //
// ./src/scripts/services/camelize.js